'use client';

import { Box, Typography } from '@mui/material';

import BusinessIcon from '@mui/icons-material/Business';
import { colorVariables, headerHeight, searchHeadHeight } from '@/constants';
import theme from '@/theme';
import ContactWidget from '../ContactWidget';
import { Vendor } from '@/lib/types/interfaces/Vendor';
import Img from '@/components/Img';

interface Props {
  service: Vendor
}

const HeadSection = ({ service }: Props) => {
  const baseDesktopWrapper = {
    paddingX: 18,
    paddingY: 0,
    zIndex: 2,
    top: headerHeight,
    position: 'fixed',
    backgroundColor: 'white',
  };

  return (
    <Box
      sx={{
        width: '100%',
        borderBottom: `1px solid ${colorVariables.separatorColor}`,
        paddingX: 3,
        paddingY: 2,
        [theme.breakpoints.up('lg')]: {
          ...baseDesktopWrapper,
          height: searchHeadHeight,
        },
        [theme.breakpoints.up('xl')]: {
          ...baseDesktopWrapper,
          height: searchHeadHeight,
        },
        [theme.breakpoints.down('lg')]: { marginTop: '70px' },
      }}
    >
      <Box
        display='flex'
        alignItems={{ xs: 'flex-start', lg: 'center' }}
        flexDirection={{ xs: 'column', lg: 'row' }}
        height='100%'
      >
        <Box sx={{
          marginRight: 3, display: 'none', maxWidth: 130, maxHeight: 130, [theme.breakpoints.up('lg')]: { display: 'block' },
        }}
        >
          <Box
            display='flex'
            width={130}
            height={130}
            marginRight={2}
            borderRadius='50%'
          >
            {!service.photo ? (
              <BusinessIcon
                sx={{
                  width: 'inherit',
                  height: 'inherit',
                  fill: '#E6E7E6',
                }}
              />
            ) : (
              <img
                src={service.photo}
                alt={service.business_name}
                width={130}
                height={130}
                style={{ borderRadius: 'inherit' }}
              />
            )}
          </Box>
        </Box>

        <Box
          display='flex'
          alignItems='center'
          flexDirection={{ xs: 'row', lg: 'column' }}
        >
          <Box sx={{
            marginRight: 3, maxWidth: 90, maxHeight: 90, display: 'block', [theme.breakpoints.up('lg')]: { display: 'none' },
          }}
          >
            {service?.photo ? (
              <Img
                src={service?.photo}
                className='avatar'
                alt={service?.description_short}
                height={90}
                width={90}
              />
            ) : (
              <BusinessIcon
                sx={{
                  width: '90px',
                  height: '90px',
                  fill: '#E6E7E6',
                }}
              />
            )}
          </Box>
          <Box
            display='flex'
            flexDirection='column'
          >
            <Typography
              variant='h4'
              sx={{
                [theme.breakpoints.down('lg')]: {
                  fontSize: '1.5rem',
                  lineHeight: '1.334',
                },
              }}
              component='h1'
              fontWeight={600}
            >
              {service.business_name}
            </Typography>
            <Typography
              variant='body1'
              fontWeight={400}
              marginTop={1}
              color={colorVariables.textDescription}
            >
              {service.city}
            </Typography>
            <ContactWidget service={service} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HeadSection;
